import * as Yup from 'yup';

// eslint-disable-next-line import/prefer-default-export
export const createResearchFieldValidationSchema = Yup.object().shape({
  name: Yup.string().required('researchField.validationErrors.nameRequired'),
  englishName: Yup.string().required('researchField.validationErrors.englishNameRequired'),
});
